/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { MODULE } from '@gearbelt/global';

import { useModulesStore } from '@/stores/modules.store';

type UseDropTableColumnParams = {
  module: MODULE;
  /**
   * The Column IDs to drop
   */
  columnIds: string[];
};
export function useDropTableColumn({ module, columnIds }: UseDropTableColumnParams) {
  const { getModule, setModuleGrouping, setModuleFilters, setModuleSorting } = useModulesStore();

  useEffect(() => {
    const columnGroupings = getModule(module).table.grouping;
    setModuleGrouping(
      module,
      columnGroupings?.filter((grouping) => !columnIds.includes(grouping)),
    );
  }, []);

  useEffect(() => {
    const columnSorting = getModule(module).table.sorting;
    if (columnSorting.key && columnIds.includes(columnSorting.key)) {
      setModuleSorting(module, {});
    }
  }, []);

  useEffect(() => {
    const columnFilters = getModule(module).table.filters;
    if (columnFilters) {
      setModuleFilters(
        module,
        columnFilters.filter((filter) => !columnIds.includes(filter.id)),
      );
    }
  }, []);
}
